import { render, staticRenderFns } from "./IframeCleanSitecore.vue?vue&type=template&id=d25716f2"
import script from "./IframeCleanSitecore.vue?vue&type=script&lang=js"
export * from "./IframeCleanSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports